module.exports = __webpack_public_path__ + "assets/img/logo.e9c75c7b.png";